import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class StatusIndicator extends React.Component {

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }
    componentDidUpdate(prevProps){

    }

    currentOption() {
        let result = {title:'NaN'}
        this.props.header.information.items.forEach(option => {
            if (this.props.title == option.value) {
                result = option
            }
        });
        // console.log(this.props.value)

        

        return result
    }

    render() {
        return (
            <div className='mt-2 '>
                <p disabled={this.conditionalSettings('disabled', true)} onChange={e => { this.props.onChange(this.props.headerkey, e.target.value) }} className='mediumiransansfont form-control text-center' defaultValue={this.props.title} style={{ backgroundColor: this.currentOption().color, color: '#3b3a40' }}>{this.currentOption().title}</p>
            </div>
        );
    }
}

export default StatusIndicator;
